import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=5049775b&scoped=true"
import script from "./top-header.vue?vue&type=script&lang=js"
export * from "./top-header.vue?vue&type=script&lang=js"
import style0 from "./top-header.vue?vue&type=style&index=0&id=5049775b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049775b",
  null
  
)

export default component.exports